import qs from "qs";
import { useStrapiApi } from "~/uses/useMyFetch";

export const fetchReviews = (params, pagination, excludedFields = []) => {
  const query = qs.stringify({
    sort: ["createdAt:desc"],
    ...params,
    pagination,
    populate: ["attachments"],
    fields: [
      "rating",
      "content",
      "pros",
      "cons",
      "reply",
      "replyAt",
      "name",
      "isPurchased",
      "createdAt",
      "youtubeVideoId",
    ].filter((field) => !excludedFields.includes(field)),
  });

  return useStrapiApi(`/product/reviews?${query}`, { fallbackData: [] });
};
